import CorpProfit from "@/views/forms/corp_profit/index.vue";
import CorpProfitEdit from "@/views/forms/corp_profit_edit/index.vue";
import GoodsVatCompare from "@/views/forms/goods_vat_compare/index.vue";
import GoodsVatSummary from "@/views/forms/goods_vat_summary/index.vue";
import Income from "@/views/forms/income/index.vue";
import Expense from "@/views/forms/expense/index.vue";
import Expense2 from "@/views/forms/expense2/index.vue";
import ExpenseTypeCompare from "@/views/forms/expense_type_compare/index.vue";
import RegisterVatCompare from "@/views/forms/register_vat_compare/index.vue";
import RegisterVatInput from "@/views/forms/register_vat_input/index.vue";
import RegisterVatInputEdit from "@/views/forms/register_vat_input_edit/index.vue";
import Deduct from "@/views/forms/deduct/index.vue";
import DeductPersonal from "@/views/forms/deduct_personal/index.vue";
import DeductHouse from "@/views/forms/deduct_house/index.vue";
import DeductInvestment from "@/views/forms/deduct_investment/index.vue";
import DeductDonation from "@/views/forms/deduct_donation/index.vue";
import TaxCompare from "@/views/forms/tax_compare/index.vue";
import CheatIncome from "@/views/forms/cheat_income/index.vue";

export default [
  {
    path: "/forms/corp_profit",
    name: "CorpProfit",
    component: CorpProfit,
  },
  {
    path: "/forms/corp_profit_edit",
    name: "CorpProfitEdit",
    component: CorpProfitEdit,
  },

  {
    path: "/forms/goods_vat_summary",
    name: "GoodsVatSummary",
    component: GoodsVatSummary,
  },
  {
    path: "/forms/goods_vat_compare",
    name: "GoodsVatCompare",
    component: GoodsVatCompare,
  },
  {
    path: "/forms/income",
    name: "Income",
    component: Income,
  },
  {
    path: "/forms/expense",
    name: "Expense",
    component: Expense,
  },
  {
    path: "/forms/expense_2",
    name: "Expense2",
    component: Expense2,
  },
  {
    path: "/forms/expense_type_compare",
    name: "ExpenseTypeCompare",
    component: ExpenseTypeCompare,
  },
  {
    path: "/forms/register_vat_input",
    name: "RegisterVatInput",
    component: RegisterVatInput,
  },
  {
    path: "/forms/register_vat_input_edit",
    name: "RegisterVatInputEdit",
    component: RegisterVatInputEdit,
  },
  {
    path: "/forms/register_vat_compare",
    name: "RegisterVatCompare",
    component: RegisterVatCompare,
  },
  {
    path: "/forms/deduct",
    name: "Deduct",
    component: Deduct,
  },
  {
    path: "/forms/deduct_personal",
    name: "DeductPersonal",
    component: DeductPersonal,
  },
  {
    path: "/forms/deduct_house",
    name: "DeductHouse",
    component: DeductHouse,
  },
  {
    path: "/forms/deduct_investment",
    name: "DeductInvestment",
    component: DeductInvestment,
  },
  {
    path: "/forms/deduct_donation",
    name: "DeductDonation",
    component: DeductDonation,
  },
  {
    path: "/forms/tax_compare",
    name: "TaxCompare",
    component: TaxCompare,
  },
  {
    path: "/forms/cheat_income",
    name: "CheatIncome",
    component: CheatIncome,
  },
];
